import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { notify } from '@mrlannigan/reapop';

const SHUTDOWN_NOTICE_ID = 'system-shutdown-notice';
const SHUTDOWN_NOTICE_SESSION_KEY = 'looking-glass-shutdown-notice-shown';

const isDashboardRoute = pathname =>
    pathname === '/dashboard' || pathname.includes('/dashboard/');

class ShutdownNoticeContainer extends Component {
    componentDidMount() {
        this.maybeShowNotice();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.maybeShowNotice();
        }
    }

    maybeShowNotice() {
        const { location } = this.props;

        if (!isDashboardRoute(location.pathname)) {
            return;
        }

        if (sessionStorage.getItem(SHUTDOWN_NOTICE_SESSION_KEY)) {
            return;
        }

        this.props.notify({
            id: SHUTDOWN_NOTICE_ID,
            title: 'Notice: Dashboard Deprecation',
            message: `This dashboard will be deprecated and no longer available after June 30, 2026.
                As part of this transition, users should begin utilizing the new upgraded dashboard experience. 
                If you have not yet received access to your new dashboard, please contact your Account 
                Representative for assistance.`,
            status: 'warning',
            dismissible: true,
            dismissAfter: 0,
        });

        sessionStorage.setItem(SHUTDOWN_NOTICE_SESSION_KEY, '1');
    }

    render() {
        return null;
    }
}

export default withRouter(connect(null, { notify })(ShutdownNoticeContainer));



// WEBPACK FOOTER //
// ./src/containers/ShutdownNoticeContainer.js